export default "__VITE_ASSET__dw5g55vW__"